import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { API_SERVER } from '../../EnvConfig/env_config';
import { setSubLoading } from "../../Redux/Services/AuthSlice";
import { NotificationSound } from "../CommonComponents/CommonNotification";
import { ApiCall, FindTranslatedKey } from "../CommonComponents/CustomHooks";
import { FormButton, InputBox } from "../CommonComponents/InputBox";
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { useNavigate } from "react-router-dom";
import { FaCheck } from "react-icons/fa";
import { ImCross } from "react-icons/im";
const ChangePassword = () => {
    const inputrefs = useRef([])
    const dispatch = useDispatch([])
    const navigate = useNavigate();
    const [showPassword, setShowPassword] = useState(false);
    const [changePasswordData, setChangePasswordData] = useState(
        {
            oldPassword: '',
            newPassword: '',
            confirmPassword: ''
        }
    )
    const [policyValidations, setPolicyValidations] = useState({
        noWhitespace: false,
        length: false,
        matchConfirmPassword: false,
        differentOldPassword: false,
        complexity: false
    });
    const handleSubmit = async () => {
        await dispatch(setSubLoading(true))
        let data = await ApiCall(`/api/User/ChangePassword`, { ...changePasswordData })
        await dispatch(setSubLoading(false))
        await NotificationSound(data.status, data.message, data.focus, inputrefs, handleReset);
        if (data.status === 'SUCCESS') {
            navigate('/login')
        }
    };
    const handleReset = () => {
        setChangePasswordData(
            {
                oldPassword: '',
                newPassword: '',
                confirmPassword: ''
            }
        )
        setPolicyValidations({
            noWhitespace: false,
            length: false,
            matchConfirmPassword: false,
            differentOldPassword: false,
            complexity: false
        });
        setShowPassword(false)
        inputrefs.current['txtOldPassword'].focus()
    }
    const handleTogglePassword = (field) => {
        setShowPassword((prevShowPassword) => ({ ...prevShowPassword, [field]: !prevShowPassword[field] }));
    };
    const validatePassword = (password, confirmPassword) => {
        if (password !== '') {
            const noWhitespace = !/\s/.test(password);
            const length = password.length >= 8 && password.length <= 15;
            const complexity = /[A-Z]/.test(password) && /[a-z]/.test(password) && /[0-9]/.test(password) && /[!@#$%^&*(),.?":{}|<>]/.test(password);
            setPolicyValidations({
                noWhitespace,
                length,
                matchConfirmPassword: password === confirmPassword,
                differentOldPassword: password !== changePasswordData.oldPassword,
                complexity
            });
        } else {
            setPolicyValidations({
                noWhitespace: false,
                length: false,
                matchConfirmPassword: false,
                differentOldPassword: false,
                complexity: false
            });
        }
    };
    const handlePasswordChange = (field, value) => {
        setChangePasswordData({ ...changePasswordData, [field]: value });

        if (field === 'newPassword') {
            validatePassword(value, changePasswordData.confirmPassword);
        } else if (field === 'confirmPassword') {
            validatePassword(changePasswordData.newPassword, value);
        }
    };
    useEffect(() => {
        document.title = 'Change Password'
        inputrefs.current['txtOldPassword'].focus()
    }, [])
    return (
        <>
            <div className='main-card card border-0'>
                <div className='pt-1 row px-3 border-0'>
                    <div className='card-header mb-1'>
                        <h6 className="m-0">  {FindTranslatedKey('Change Password')} </h6>
                    </div>
                    <div className='card-body pb-3'>
                        <div className='row'>
                            <div className='col-sm-4'>
                                <div className="d-flex mb-1" style={{ position: "relative" }}>
                                    <InputBox
                                        id="txtOldPassword"
                                        type={showPassword.oldPassword ? 'text' : 'password'}
                                        divclassname='col-md-12 col-12 mb-2'
                                        label='Old Password'
                                        PlaceHolderText='Old Password'
                                        required={true}
                                        inputrefs={inputrefs}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                inputrefs.current['txtNewPassword'].focus()
                                            }
                                        }}
                                        maxLength='15'
                                        value={changePasswordData.oldPassword}
                                        onChange={(e) => setChangePasswordData({ ...changePasswordData, oldPassword: e.target.value })}
                                    />
                                    <span style={{ position: "relative", right: "26px", top: "23px", cursor: "pointer", height: "2px" }} onClick={() => handleTogglePassword('oldPassword')}>
                                        {showPassword.oldPassword ? <FaEyeSlash style={{ color: "#78A7FE" }} /> : <FaEye style={{ color: "#78A7FE" }} />}
                                    </span>
                                </div>

                                <div className="d-flex mb-1" style={{ position: "relative" }}>
                                    <InputBox
                                        required={true}
                                        maxLength='15'
                                        divclassname='col-md-12 col-12 mb-2'
                                        label='New Password'
                                        PlaceHolderText='New Password'
                                        inputrefs={inputrefs}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                inputrefs.current['txtConfirmPassword'].focus()
                                            }
                                        }}
                                        id="txtNewPassword"
                                        type={showPassword.newPassword ? 'text' : 'password'}
                                        value={changePasswordData.newPassword}
                                        onChange={(e) => handlePasswordChange('newPassword', e.target.value)}
                                    />
                                    <span style={{ position: "relative", right: "26px", top: "23px", cursor: "pointer", height: "2px" }} onClick={() => handleTogglePassword('newPassword')}>
                                        {showPassword.newPassword ? <FaEyeSlash style={{ color: "#78A7FE" }} /> : <FaEye style={{ color: "#78A7FE" }} />}
                                    </span>
                                </div>
                                <div className="d-flex mb-1" style={{ position: "relative" }}>
                                    <InputBox
                                        label={'Confirm Password'}
                                        PlaceHolderText={'Confirm Password'}
                                        required={true}
                                        divclassname='col-md-12 col-12 mb-2'
                                        inputrefs={inputrefs}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                inputrefs.current['btnSub'].focus()
                                            }
                                        }}
                                        id="txtConfirmPassword"
                                        maxLength='15'
                                        type={showPassword.confirmPassword ? 'text' : 'password'}
                                        value={changePasswordData.confirmPassword}
                                        onChange={(e) => handlePasswordChange('confirmPassword', e.target.value)}
                                    />
                                    <span style={{ position: "relative", right: "26px", top: "23px", cursor: "pointer", height: "2px" }} onClick={() => handleTogglePassword('confirmPassword')}>
                                        {showPassword.confirmPassword ? <FaEyeSlash style={{ color: "#78A7FE" }} /> : <FaEye style={{ color: "#78A7FE" }} />}
                                    </span>
                                </div>
                                <FormButton
                                    id={'btnSub'}
                                    inputrefs={inputrefs}
                                    handleSubmit={handleSubmit}
                                    Export={false}
                                    handleClear={handleReset}
                                />
                            </div>
                            <div className='col-sm-8'>
                                <div className='password-policy-border'>
                                    <div className='w-100 py-2 password-policy px-3'>
                                        <h6 className="m-0 font-weight-bold text-white">{FindTranslatedKey('Password Policy')}</h6>
                                    </div>
                                    <div className='p-3'>
                                        <div className="form-group change_password px-2">
                                            <ol>
                                                <li className='changepara' >
                                                    {FindTranslatedKey('White spaces not allowed.')} {policyValidations.noWhitespace ? <FaCheck style={{ color: "green",  }} /> : <ImCross className='checkSymbol' style={{ color: "red", fontSize: "10px", marginBottom: "4px" }} />}
                                                </li>
                                                <li className='changepara'>
                                                    {FindTranslatedKey('Password must be 8 to 15 character(s).')}    {policyValidations.length ? <FaCheck style={{ color: "green", marginBottom: "4px" }} /> : <ImCross className='checkSymbol' style={{ color: "red", fontSize: "10px", marginBottom: "4px" }} />}
                                                </li>
                                                <li className='changepara'>
                                                    {FindTranslatedKey('New password and confirm password should be same.')}   {policyValidations.matchConfirmPassword ? <FaCheck style={{ color: "green", marginBottom: "4px" }} /> : <ImCross className='checkSymbol' style={{ color: "red", fontSize: "10px", marginBottom: "4px" }} />}
                                                </li>
                                                <li className='changepara'>
                                                    {FindTranslatedKey('Old password and new password should be different.')}   {policyValidations.differentOldPassword ? <FaCheck style={{ color: "green", marginBottom: "4px" }} /> : <ImCross className='checkSymbol' style={{ color: "red", fontSize: "10px", marginBottom: "4px" }} />}
                                                </li>
                                                <li className='changepara'>
                                                    {FindTranslatedKey('Password must be combination of at least one numeric and one uppercase letter and one lowercase and special character [$#!()].')}  {policyValidations.complexity ? <FaCheck style={{ color: "green", marginBottom: "4px" }} /> : <ImCross className='checkSymbol' style={{ color: "red", fontSize: "10px", marginBottom: "4px" }} />}
                                                </li>
                                            </ol>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default ChangePassword;



